module.exports = __webpack_public_path__ + "static/media/drink082022.00f70068.pdf";